import {
	faHandHoldingDollar,
	faEnvelope,
	faDisplayChartUpCircleDollar,
} from '@fortawesome/pro-regular-svg-icons'

export const rcptStatuses = [
	{
		value: "mail",
		label: "Notifica via mail",
		icon: faEnvelope,
	},
	{
		value: "telematic",
		label: "Servizio telematico",
		icon: faDisplayChartUpCircleDollar,
	},
	{
		value: "hand",
		label:"Consegna manuale",
		icon: faHandHoldingDollar,
	},
]